import { ReactNode, useState } from 'react';
import {
  Box,
  Collapse,
  Flex,
  Icon,
  Stack,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';
import { ChevronDown, ChevronLeft, ChevronRight } from 'lucide-react';

interface INavSectionProps {
  title: string;
  children: ReactNode;
}

export function NavSection({ title, children }: INavSectionProps) {
  const [open, setOpen] = useState(() => {
    const saved = localStorage.getItem(`navsection${title}`);
    return saved !== null ? saved === 'true' : true;
  });
  const color = useColorModeValue('gray.800', 'white');
  const dividerColor = useColorModeValue('gray.100', 'gray.900');

  const handleChangeOpen = () => {
    localStorage.setItem(`navsection${title}`, String(!open));
    setOpen(prev => !prev);
  };

  return (
    <>
      <Box w="100%" px="4" cursor="pointer" onClick={() => handleChangeOpen()}>
        <Flex
          py="2"
          rounded="2xl"
          w="100%"
          justify="space-between"
          _hover={{ bg: dividerColor }}
        >
          <Text px="2" fontWeight="medium" color={color} fontSize="sm">
            {title}
          </Text>
          <Icon
            as={open ? ChevronDown : ChevronLeft}
            fontSize={18}
            mr="2"
            color={color}
          />
        </Flex>
      </Box>
      <Box w="100%" px="4">
        <Collapse in={open}>
          <Stack align="stretch">{children}</Stack>
        </Collapse>
      </Box>
    </>
  );
}
